import { openCrisp } from '@/helpers';
import { Button, FooterHelp } from '@shopify/polaris';
import RegularText from '../RegularText';

const FooterHelpText = ({ linkDocs, isShowContact }: { linkDocs: string; isShowContact: boolean }) => {
  return (
    <FooterHelp>
      <RegularText>Need help? </RegularText>
      <Button onClick={() => window.open(linkDocs)} variant="plain">
        View Document
      </Button>{' '}
      {isShowContact && (
        <>
          <RegularText>or </RegularText>
          <Button onClick={openCrisp} variant="plain">
            Contact Support
          </Button>
        </>
      )}
    </FooterHelp>
  );
};

export default FooterHelpText;
